import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';
import ShoppingBagRoundedIcon from '@mui/icons-material/ShoppingBagRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { useLocation } from '../../contexts/LocationContext'; // Location Context
import { useNavigate } from 'react-router-dom'; // For Navigation

const ModernAppBar = ({ loggedIn, setLoggedIn }) => {
  const { location } = useLocation(); // Get location from context
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if mobile

  // Menu State
  const [anchorEl, setAnchorEl] = useState(null);

  // Mobile Menu Handlers
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  // Logout Function
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setLoggedIn(false);
    handleMenuClose();
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: '#31C48D', // Green
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        paddingX: 2,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* Logo and Location */}
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ color: 'white', cursor: 'pointer', fontFamily: 'Space Grotesk, sans-serif' }}
          >
            AidNix
          </Typography>

          {/* Location */}
          <Box
            display="flex"
            alignItems="center"
            sx={{
              cursor: 'pointer',
              '&:hover': { color: '#FFD700' },
            }}
            onClick={() => navigate('/location-search')} // Navigate to Location Page
          >
            <FmdGoodRoundedIcon sx={{ color: 'white' }} />
            <Typography variant="body2" sx={{ color: 'white' }}>
              {location.city || 'Select Location'}
            </Typography>
            <ArrowDropDownIcon sx={{ color: 'white' }} />
          </Box>
        </Box>

        {!isMobile ? (
          // Desktop View Buttons
          <Box display="flex" alignItems="center" gap={3}>
            {loggedIn ? (
              <Button
                startIcon={<PersonRoundedIcon />}
                sx={{ color: 'white', fontWeight: 500, '&:hover': { color: '#FFD700' } }}
                onClick={handleLogout}
              >
                Logout
              </Button>
            ) : (
              <Button
                startIcon={<PersonRoundedIcon />}
                sx={{ color: 'white', fontWeight: 500, '&:hover': { color: '#FFD700' } }}
                onClick={() => navigate('/login')}
              >
                Login
              </Button>
            )}
            <Button
              startIcon={<HelpRoundedIcon />}
              sx={{ color: 'white', fontWeight: 500, '&:hover': { color: '#FFD700' } }}
              onClick={() => navigate('/help')}
            >
              Need Help
            </Button>
            <IconButton sx={{ color: 'white' }} onClick={() => navigate('/cart')}>
              <ShoppingBagRoundedIcon />
            </IconButton>
          </Box>
        ) : (
          // Mobile Menu
          <IconButton sx={{ color: 'white' }} onClick={handleMenuOpen}>
            <MenuRoundedIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* Mobile Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        {loggedIn ? (
          <MenuItem onClick={handleLogout}>
            <PersonRoundedIcon sx={{ marginRight: '10px' }} /> Logout
          </MenuItem>
        ) : (
          <MenuItem onClick={() => navigate('/login')}>
            <PersonRoundedIcon sx={{ marginRight: '10px' }} /> Login
          </MenuItem>
        )}
        <MenuItem onClick={() => navigate('/help')}>
          <HelpRoundedIcon sx={{ marginRight: '10px' }} /> Need Help
        </MenuItem>
        <MenuItem onClick={() => navigate('/cart')}>
          <ShoppingBagRoundedIcon sx={{ marginRight: '10px' }} /> Cart
        </MenuItem>
      </Menu>
    </AppBar>
  );
};

export default ModernAppBar;